export enum TipoImagem {
    DocumentoIdentificador = 1,
    DocNotificacaoOuPenalidade = 2,
    CNHdoInfrator = 2,
    FormularioIndicacao = 3,
    DocResponsabilidade = 4,
    DocComprobatorio = 5
}
